export default "__VITE_ASSET__7d6eb45b__"